<template>
  <v-row>
    <v-col cols="auto">
      <v-badge
        bottom
        overlap
        icon="check"
        :color="answer.textAnswer == null ? 'lighttext' : 'success'"
        class="mr-8"
      >
        <user-avatar size="40" :user="user"></user-avatar>
      </v-badge>
    </v-col>
    <v-col cols="auto" v-if="showEdit">
      <v-btn class="mr-4" outlined color="performance" @click="$emit('edit')">
        {{ answer.textAnswer ? "Edit" : "Answer" }}
      </v-btn>
    </v-col>
    <v-col v-if="showAnswer" class="my-auto">
      <div
        class="flex-grow-1 pa-2 rounded-lg white-space-pre-line"
        v-if="answer.textAnswer"
        v-bind:style="{
          backgroundColor: getColor(
            $vuetify.theme.themes.light.secondarytext,
            0.1
          )
        }"
      >
        {{ answer.textAnswer }}
      </div>
      <div v-else class="subtitle-1">
        Waiting on Answer
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AnnualReviewQuestionTextAnswer",
  props: {
    answer: { type: Object },
    user: { type: Object },
    showAnswer: { type: Boolean, default: true },
    showEdit: { type: Boolean, default: true }
  }
};
</script>
